function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.48778 9.02561C3.02603 9.1625 2.84265 9.7314 3.15577 10.1114C4.50414 11.748 7.89448 15.2894 11.9816 15.2894C16.1042 15.2894 19.5178 11.6861 20.8421 10.0693C21.1375 9.70849 20.9625 9.17046 20.5252 9.04105C20.2759 8.96726 20.0106 9.0537 19.8407 9.25817C18.6091 10.7409 15.5195 13.9714 11.9816 13.9714C8.67514 13.9714 5.08009 10.2651 4.1038 9.20057C3.94208 9.02423 3.71267 8.95894 3.48778 9.02561Z",
  fill: "#90919C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.99046 11.9082C6.29094 12.1907 6.3153 12.6741 6.04487 12.988L5.14201 14.036C4.87158 14.3499 4.40878 14.3753 4.1083 14.0928C3.80783 13.8103 3.78347 13.3269 4.0539 13.013L4.95676 11.965C5.22719 11.6511 5.68999 11.6257 5.99046 11.9082Z",
  fill: "#90919C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.42429 13.8708C8.79843 14.0307 8.97766 14.4772 8.8246 14.868L8.4378 15.8557C8.28474 16.2466 7.85735 16.4338 7.4832 16.2739C7.10906 16.114 6.92983 15.6676 7.08289 15.2767L7.46969 14.289C7.62275 13.8982 8.05014 13.7109 8.42429 13.8708Z",
  fill: "#90919C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0333 14.3778C12.4372 14.3953 12.751 14.7516 12.7342 15.1736L12.6906 16.2672C12.6737 16.6891 12.3327 17.0169 11.9288 16.9993C11.5249 16.9817 11.2111 16.6255 11.2279 16.2035L11.2716 15.1099C11.2884 14.688 11.6294 14.3602 12.0333 14.3778Z",
  fill: "#90919C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5181 13.7987C15.883 13.6172 16.3198 13.7791 16.4936 14.1603L16.9099 15.0735C17.0837 15.4548 16.9287 15.911 16.5637 16.0926C16.1987 16.2742 15.762 16.1123 15.5882 15.731L15.1719 14.8178C14.9981 14.4365 15.1531 13.9803 15.5181 13.7987Z",
  fill: "#90919C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7074 10.9516C18.9858 10.6454 19.4491 10.633 19.7422 10.9238L20.7722 11.946C21.0653 12.2368 21.0771 12.7208 20.7987 13.027C20.5203 13.3331 20.057 13.3455 19.7639 13.0547L18.734 12.0325C18.4409 11.7417 18.429 11.2577 18.7074 10.9516Z",
  fill: "#90919C"
});

var SvgEyeClose = function SvgEyeClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye_close.b02264e0.svg";
export { ForwardRef as ReactComponent };